import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3">
            Everything you need to know about the AllChinaBuy Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-colors ${
                  openIndex === index ? 'bg-primary-100 text-primary-600' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-background-50 rounded-xl border border-background-200 p-5 md:p-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
              <span className="text-xl font-heading font-bold text-accent-600">9.8</span>
            </div>
            <div className="flex-1">
              <p className="text-sm text-foreground-700 italic leading-relaxed">
                &ldquo;The AllChinaBuy Spreadsheet has completely changed how I shop. I have saved thousands of dollars on sneakers and clothing while getting authentic products every time. The weekly updates keep everything fresh.&rdquo;
              </p>
              <div className="flex items-center gap-3 mt-3">
                <div className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center">
                  <i className="ri-user-line text-secondary-600 text-sm"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">China Buying Research Team</p>
                  <p className="text-xs text-foreground-500">5+ Years Experience in Cross-Border Purchasing</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}